import React from 'react'
import InformationNote from './InformationNote'

const PhotoPointNote: React.FC = () => {
  return (
    <InformationNote
      title="撮影ポイント"
      notes={[
        '写っている対象が判断できる程度の明暗で撮影する',
        'ブレずにはっきりした写真を撮影する',
      ]}
    />
  )
}

export default React.memo(PhotoPointNote)
